import React from 'react'

import { OnSchedUtils } from '../../../../../../utils'


const SubmitAllocationRow = ({ element, newBlock, setNewBlock, nullifyValues, allocations, setAllocations }) => {
  if (!newBlock) return null

  
  const addBlock = e => {
    e.preventDefault();
    let blockData = {};

    if (document.getElementsByName('startDate')[0]?.value) blockData.startDate = document.getElementsByName('startDate')[0]?.value;
    if (document.getElementsByName('endDate')[0]?.value) blockData.endDate = document.getElementsByName('endDate')[0]?.value;
    if (document.getElementsByName('startTime')[0]?.value) blockData.startTime = document.getElementsByName('startTime')[0]?.value;
    if (document.getElementsByName('endTime')[0]?.value) blockData.endTime = document.getElementsByName('endTime')[0]?.value;
    if (document.getElementsByName('repeat')[0].checked) blockData.repeat = document.getElementsByName('repeat')[0].checked;
    if (document.getElementsByName('interval')[0]?.value) blockData.interval = document.getElementsByName('interval')[0]?.value;
    if (document.getElementsByName('repeats')[0]?.value) blockData.repeats = document.getElementsByName('repeats')[0]?.value;
    if (document.getElementsByName('weekdays')[0]?.value) blockData.weekdays = document.getElementsByName('weekdays')[0]?.value;

    const newAllocations = allocations;
    newAllocations.push(blockData);

    setAllocations(newAllocations);
    nullifyValues();
    setNewBlock(false);
  }

  const cancel = e => {
    e.preventDefault();
    nullifyValues();
    setNewBlock(false);
  }
  
  return (
    <div className='SubmitAllocationRow'>
      <button 
        className='OnSchedBtn onsched-secondary-background-color onsched-primary-color'
        onClick={addBlock}
      >
        {OnSchedUtils.Internationalize(element, 'utility_save')}
      </button>
      <button 
        className='OnSchedBtn onsched-secondary-background-color onsched-danger-color'
        onClick={cancel}
      >
        {OnSchedUtils.Internationalize(element, 'utility_cancel')}
      </button>
    </div>
  )
}

export default SubmitAllocationRow